// extracted by mini-css-extract-plugin
export default {"searchWrapper":"neurons_searchWrapper__94rUE","searchInputGroup":"neurons_searchInputGroup__43d+2"};